<template>
	<div>
		<el-dialog :title="$t('main.ImportOptions')" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false" modal-append-to-body>
			<div>
				<div class="uploadData">
					<el-upload
						class="upload-demo"
						drag
						:action="action"
						multiple
						:show-file-list="false"
						:on-success="handleSuccess"
						name="multipartFile"
						:accept="fileAccept"
						:with-credentials="true"
						:data="QiniuData"
					>
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">{{$t('main.ClickToUpload')}}...</div>
					</el-upload>
				</div>
				<div class="dowloadText"><i class="el-icon-download" @click="dow">{{$t('main.Download')}}</i></div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="dialogVisible = false">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			fileList: [],
			dialogVisible: false,
			fileAccept: '.xls,.xlsx',
			action: '',
			QiniuData: {
				Authorization: ''
			}
		};
	},
	created() {
		this.action = this.$config.service.importStageQues;
		let token = window.localStorage.getItem('token');
		this.QiniuData.Authorization = token ? 'Bearer ' + token : '';
	},
	methods: {
		handleSuccess(response, file, fileList) {
			console.log('上传', response, file, fileList);
			if (response.code == 0) {
				this.$emit('uploadDataOk', response.resultBody);
				this.$message.success(response.message);
				this.dialogVisible = false;
			} else {
				this.$message.error(response.message);
			}
		},
		dow() {
			this.$axios({
				method: 'get',
				url: './template/级联题模板.xlsx',
				responseType: 'blob',
			}).then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				let fname = '级联题模板.xlsx';
				link.href = url;
				link.setAttribute('download', fname);
				document.body.appendChild(link);
				link.click();
				this.dialogImport = false;
			});
		},
		openUpload() {
			this.dialogVisible = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.uploadData {
	text-align: center;
}
.dowloadText {
	margin-top: 20px;
	cursor: pointer;
	.el-icon-download:hover {
		color: #0080ff;
	}
}
</style>
